// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TrafficDistributionSection_wrapper__1DM1V","desktop":"TrafficDistributionSection_desktop__1SxiK","image":"TrafficDistributionSection_image__1DRWR"};